import { render, staticRenderFns } from "./mo-contact-card.html?vue&type=template&id=126814e9&external"
import script from "./mo-contact-card.ts?vue&type=script&lang=ts&external"
export * from "./mo-contact-card.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-contact-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports